"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokChooseUsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Section Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Header</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Why Choose Us"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Why Choose Us?"
            />
            <TextEditor
              label="Description"
              value={content.description}
              onChange={(v) => handleChange({ ...content, description: v })}
              placeholder="Explore over 8,000+ website templates..."
              multiline
            />
          </div>

          {/* Features */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Features</h4>
            <ListItemEditor
              label="Items"
              items={content.items || [
                { title: "Instant downloads & license delivery", description: "Hok is affordable for all WordPress developers...", icon: "download" },
                { title: "Tax & invoicing automation", description: "Hok is affordable for all WordPress developers...", icon: "receipt" },
                { title: "Analytics & sales reporting", description: "Hok is affordable for all WordPress developers...", icon: "chart" },
                { title: "Top Reviews & moderation", description: "Hok is affordable for all WordPress developers...", icon: "star" },
              ]}
              itemSchema={[
                { key: "title", label: "Title", type: "text" },
                { key: "description", label: "Description", type: "textarea" },
                { key: "image", label: "Image / Icon", type: "image" },
              ]}
              onChange={(items) => handleChange({ ...content, items: items })}
              addItemText="Add Feature"
            />
          </div>
        </>
      }
    />
  );
}
